export interface WicketDeviceCodeAuthResponse {
  device_code: string;
  user_code: string;
  application_id: string;
  verification_uri: string;
  verification_uri_complete: string;
  interval: number;
  expires_in: number;
}
